module.exports = __webpack_public_path__ + "static/media/circle10.8c88afc3.svg";